export enum PrinterFormat {
  WIDE = 'WIDE',
  NARROW = 'NARROW',
  XML = 'XML',
}
